import { decodeObject } from '@packages/domain/utils/encoding/encoding';
import get from 'lodash/get';
import omit from 'lodash/omit';

export const EmbeddedRepository = {
  isEnabled() {
    return window.xprops !== undefined;
  },

  getProps() {
    if (!window.xprops) {
      return {};
    }
    return decodeObject(omit(window.xprops, 'uid'));
  },

  getProp(prop, defaultValue) {
    return get(this.getProps(), prop, defaultValue);
  },
};
